import styled from "styled-components";

type OutlinedButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  // include any other props you expect to use
};

export const OutlinedButton = styled.button.attrs<OutlinedButtonProps>(
  (props) => ({
    className: `rounded cursor-pointer text-sm font-medium ${
      props.className || ""
    }`,
  })
)`
  border: 1px solid var(--primaryPurpleMain);
  background-color: white;
  color: var(--primaryPurpleMain);
  padding: 0.5rem 1rem;
  margin-left: 0.5rem;
  /* width: 10%; */
`;
export const GenOutlinedBtn = styled(OutlinedButton)`
  width: 100%;
`;
interface ButtonContainerProps {
  currentPage?: number;
}
export const ButtonConPos = styled.div`
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const ButtonContainer = styled.div<ButtonContainerProps>`
  display: flex;
  @media screen and (max-width: 425px) {
    justify-content: ${(props) =>
      props.currentPage === 0 ? "flex-end" : "space-between"};
  }
  /* width: 10%; */
  justify-content: flex-end;
  width: 100%;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
  margin-top: 10px;
`;
// py-2 px-10
export const BtnContainerDiv = styled.div`
  display: flex;
  margin: 0 auto;
  /* border: 1px solid gold; */
  @media screen and (max-width: 1024px) {
    width: 100%;
    /* width: 20%; */
  }
  @media screen and (max-width: 768px) {
    justify-content: space-between;
  }
  @media screen and (max-width: 425px) {
    /* width: 50%; */
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    margin: 5px 0;
  }
`;
interface ButtonProps {
  nextOrSubmit?: boolean;
  fixedWidth?: boolean;
  displayFlex?: boolean;
}
// py-2 px-10
export const FilledButton = styled.button.attrs({
  className: "rounded text-sm font-medium",
})<ButtonProps>`
  border: 1px solid var(--primaryPurpleMain);
  background-color: var(--primaryPurpleMain);
  color: white;
  padding: 0.5rem 1rem;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  width: ${(props) => (props.fixedWidth ? "13rem" : "unset")};
  ${(props) =>
    props.displayFlex &&
    `display: flex;
    justify-content: center;
    align-items: center;
    `};
  /* width: 50%; */
  /* width: ${(props) => (!props.nextOrSubmit ? "100%" : "30%")}; */
  /* height: 40px; */
`;
export const GenFilledBtn = styled(FilledButton)`
  width: 100%;
  height: 40px;
  @media screen and (max-width: 768px) {
    height: 35px;
  }
`;
